export enum MediaTypesEnum {
  AUDIO = 'AUDIO',
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  YOUTUBE_VIDEO = 'YOUTUBE_VIDEO',
}

export enum CmsMediaTypeEnum {
  Audio = 'media--audio',
  Image = 'media--image',
  RemoteVideo = 'media--remote_video',
  Video = 'media--video',
}
